import sortBy from 'lodash/sortBy';

import {
  IOrganization,
  IOrganizationGroup,
  IUser,
} from 'common/src/types/interfaces';

import {
  autoCompleteType,
  textInputType,
} from '../../common/forms/FormFieldTypes';

export const defaultValues = (entity: Partial<IOrganizationGroup>): any => ({
  name: entity.name ?? '',
  organizations: entity.organizations?.map((org) => org.id) ?? [],
  users: entity.users?.map((user) => user.id) ?? [],
});

export const getFields = (
  organizations: Partial<IOrganization>[],
  users: Partial<IUser>[],
) => {
  const formFieldsConfiguration: Array<textInputType | autoCompleteType> = [
    {
      label: 'Organization Group Name',
      name: 'name',
      placeholder: 'Organization Group Name',
      required: true,
      type: 'textInput',
    },
    {
      label: 'Organizations',
      name: 'organizations',
      placeholder: 'Organizations',
      required: true,
      type: 'autocomplete',
      multiple: true,
      options: sortBy(organizations, (o) => o.name.toLowerCase()).map(
        (organization) => ({
          label: organization.name,
          value: organization.id,
          key: organization.id,
          disabled: !organization.isActive,
        }),
      ),
    },
    {
      label: 'Users',
      name: 'users',
      placeholder: 'Users',
      required: false,
      type: 'autocomplete',
      multiple: true,
      options: sortBy(users, (u) => u.name.toLowerCase()).map((user) => ({
        label: user.name,
        value: user.id,
        key: user.id,
        disabled: !user.isActive,
      })),
    },
  ];
  return formFieldsConfiguration;
};
